<div class="pagination-container">
  <ngb-pagination
    [collectionSize]="totalRows"
    [page]="currentPage"
    [pageSize]="pageSize"
    (pageChange)="onPageChange($event)"
    [maxSize]="5"
    [rotate]="true">
  </ngb-pagination>

  <div ngbDropdown class="dropdown pagination-dropdown">
    <button ngbDropdownToggle class="btn btn-secondary pagination-button" type="button">Page Size: {{ pageSize }}</button>
    <div ngbDropdownMenu class="dropdown-menu pagination-dropdown-menu">
      @for (size of pageSizeOptions; track size) {
        <button class="dropdown-item pagination-dropdown-item" (click)="onPageSizeChange(size)">
          {{ size }}
        </button>
      }
    </div>
  </div>
  <div class="pagination-information">{{ calculateStartIndex() }} - {{ calculateTotalRowsOnPage() }} of {{ totalRows }} </div>
</div>